import { useFeatureFlag } from './useFeatureFlag';

export const useIsFeatureEnabled = (feature: string): boolean => !!useFeatureFlag(feature).enabled;
